<template>
    <div class="detail-container">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{form.promotionName || '新建'}}</h2>
        </div>
        <el-tabs type="border-card" tab-position="top" v-model="tabSel"  v-loading="loading">
            <el-tab-pane label="基本信息" name="tab0">
                <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
                    <el-button size="small" type="danger" @click="addPromotion(form)">{{proId==0?'下一步':'保 存'}}</el-button>
                </div>
                <el-form :model="form" label-width="120px">
                    <el-form-item label="ID">
                        <el-input v-model=promotionId :disabled="true"></el-input>
                    </el-form-item>
                <el-form-item label="促销名称" :required="true">
                    <el-input v-model=form.promotionName clearable  placeholder="促销名称"></el-input>
                </el-form-item>
                <el-form-item label="售卖单位">
                    <el-input
                        v-model="form.unit"
                        clearable
                        placeholder="请输入售卖单位(如:份、套、盒等)"
                        maxlength="20">
                    </el-input>
                </el-form-item>
                    <el-form-item label="开始日期" :required="true">
                        <el-date-picker
                            v-model=form.beginTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" :required="true">
                        <el-date-picker
                            v-model=form.endTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="到计时">
                        <el-select v-model="form.countdown"  placeholder="是否展示到计时">
                            <el-option v-for="item in countdownList"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="限量方式" :required="true">
                        <el-select v-model="form.promotionType"  placeholder="促销限量">
                            <el-option label="按总数限量" value="1"></el-option>
                            <el-option label="每天限量" value="2"></el-option>
                        </el-select>
                        <el-label>按总数限量：限量数是促销商品的总数量，每天限量：限量数是每天的上限</el-label>
                    </el-form-item>
                    <el-form-item label="限量数" :required="true">
                        <el-input-number v-model="form.limitCount" :min="0" :max="100000" label="限量数"></el-input-number>
<!--                        <el-label>0不限量</el-label>-->
                    </el-form-item>

                    <el-form-item label="限购量" :required="true">
                        <el-input-number v-model="form.userLimitCount" :min="0" :max="100000" label="用户限购数"></el-input-number>
                        <el-label> 可以购买几个，1元秒杀填1(限量1个)  0不限量 促销名中包含秒杀或实际销售价格小于等于1元时会自动加到奶卡商品中</el-label>
                    </el-form-item>
                    <el-form-item label="限购类型" v-show="form.userLimitCount>0">
                        <el-select v-model="form.limitType" placeholder="限购类型" >
                            <el-option v-for="item in limitTypeData"
                                       :key="item.value"
                                       :label="item.name"
                                       :value="item.value"
                            ></el-option>
                        </el-select>
                        <el-label> 按单限购，每单只能购买{{form.userLimitCount}}次，按用户限购 用户只能买{{form.userLimitCount}}次</el-label>
                    </el-form-item>
                    <el-form-item label="虚拟销售数">
                        <el-input-number v-model="form.saled" :min="0" :max="100000" label="虚拟销售数"></el-input-number>
                        <el-label>展示给用户已经卖了多少了，一个假的已销售数，0是不作假</el-label>
                    </el-form-item>
                    <el-form-item label="绑定活动">
                        <el-select v-model="form.activeNo" clearable filterable  placeholder="促销活动">
                            <el-option v-for="item in activeData"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-label>已上线且时间不过期的活动，找不到看活动状态是否在线，活动时间是否有效期内</el-label>
                    </el-form-item>
                    <el-form-item label="可用券" :required="true">
                        <el-select v-model="form.useCoupon"  placeholder="可用券">
                            <el-option v-for="item in useCashList"
                                       :key="item.value"
                                       :label="item.name"
                                       :value="item.value"
                            ></el-option>
                        </el-select>
                        <el-label>该商品能不能用券，不会限制到整单上</el-label>
                    </el-form-item>
                    <el-form-item label="VIP专享">
                        <el-select v-model="form.isvip" placeholder="是否VIP">
                            <el-option v-for="item in selArr"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"
                            ></el-option>
                        </el-select>
                        <el-label>是否只有VIP能购买</el-label>
                    </el-form-item>
                    <el-form-item label="关联VIP权益" v-if="form.isvip==1">
                        <el-select v-model="form.vipRightType"  placeholder="关联VIP权益">
                            <el-option v-for="item in vipRightTypeData"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                        <el-label>拥有哪项会员权益才能购买</el-label>
                    </el-form-item>
                    <el-form-item label="是否参与会员日">
                        <el-checkbox v-model="form.vipDayRight" name="type" :true-label="1" :false-label="0"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="是否参与日常折扣">
                        <el-checkbox v-model="form.vipEverydayRight" name="type" :true-label="1" :false-label="0"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="原价">
                        <el-input v-model="form.originPrice" :disabled="true" clearable placeholder="原价" ></el-input>
                    </el-form-item>
                    <el-form-item label="销售价" :required="true">
                        <el-input v-model="form.promotionPrice" clearable  placeholder="销售价"></el-input>
                        <el-label>只有1元的才会自动同步到奶卡专区，低于和高于都不会同步！！！</el-label>
                    </el-form-item>
                    <el-form-item label="是否免邮费" :required="true">
                      <el-select v-model="form.isFreeFreight"  placeholder="是否免邮费">
                      <el-option v-for="item in selArr"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select><el-label>只有特殊促销才设置为免邮，设置免邮后用户无需达到包邮金额即可免运费，请谨慎设置！！！</el-label>
                    </el-form-item>
                    <el-form-item label="详情页可分享" :required="true">
                        <el-select v-model="form.shareEnable"  placeholder="详情页可分享">
                            <el-option v-for="item in shareEnableArr"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select><el-label>包裹卡抽奖商品需配置为不可分享，其他促销配置无效！！！</el-label>
                    </el-form-item>
                    <el-form-item label="售卖仓库">
                        <el-select 
                            v-model="form.storeCode" 
                            multiple 
                            clearable 
                            filterable
                            placeholder="售卖仓库"
                            @change="handleStoreCodesChange">
                            <el-option
                                v-for="item in storeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
<!--                <template>-->
                    <el-button type="success" size="small" @click="addRow()">添加一行</el-button>
<!--                    <div class="drag-container" style="margin-top: 10px">-->
                        <el-table class="drag-container" :data="form.formProducts" size="mini">
                            <el-table-column type="index" label="序号"></el-table-column>
                            <el-table-column label="选择产品">
                                <template slot-scope="scope" >
                                    <el-select size="mini" v-model="scope.row.proId" filterable clearable placeholder="选择单品"
                                               @change="handleItemChange(scope.row)">
                                        <el-option
                                            v-for="item in products"
                                            :key="item.proId"
                                            :label="item.proName"
                                            :value="item.proId">
                                            <span style="float: left">{{ item.proName }}</span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.barCode }}</span>
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="barCode" label="69码"></el-table-column>
                            <el-table-column prop="price" label="产品价格"></el-table-column>
                            <el-table-column label="选择数量">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.proCount" :min="1" :max="1000" :step="1" size="mini" @change="handleOriginPriceChange(scope.row)"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="danger" plain size="mini" icon="el-icon-delete" @click="delRow(scope.$index)" circle></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
<!--                    </div>-->
<!--                </template>-->
                    <!--            <el-form-item label="每单限购数">-->
                    <!--                <el-input-number v-model="formProduct.limitCount" :min="1" :max="100000" label="每日限购数"></el-input-number>-->
                    <!--            </el-form-item>-->
                    <!--            <el-form-item label="排序号">-->
                    <!--                <el-input-number v-model="formProduct.sequence" :min="1" :max="1000" label="排序号"></el-input-number>-->
                    <!--            </el-form-item>-->
                    <!--            <el-form-item label="是否显示">-->
                    <!--                <el-select v-model="formProduct.isshow"   placeholder="是否显示">-->
                    <!--                    <el-option v-for="item in showData"-->
                    <!--                               :key="item.id"-->
                    <!--                               :label="item.name"-->
                    <!--                               :value="item.id">-->
                    <!--                    </el-option>-->
                    <!--                </el-select>-->
                    <!--            </el-form-item>-->

            </el-tab-pane>
            <el-tab-pane label="促销图片" v-if="promotionId!=0" name="tab1">
                <pictureM></pictureM>
            </el-tab-pane>
            <el-tab-pane label="促销专用券" v-if="this.canUseCash==1" name="tab2">
                <productCash :itemId="promotionId" :itemType="1"></productCash>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {getPromotionDetail,addPromotionDetail,getProducts,getPromotionLimitTypeList, getWxStoreSearch,getOptionActiveList,getMallItemConfigUseStatusList} from '@/api/api'
import pictureM from '@/components/picture'
import productCash from '@/components/coupon/productCash'

export default {
    data(){
        return {
            promotionId:this.$route.query.promotionId,
            tabSel:'tab0',
            activeData:[],
            products:[],
            limitTypeData:[],
            loading:true,
            canUseCash:0,
            countdownList:[{id:0,name:'否'},{id:1,name:'是'}],
            selArr:[{label:'否',value:'0'},{label:'是',value:'1'}],
            shareEnableArr:[{label:'可分享',value:1},{label:'不可分享(包裹卡商品选我)',value:0}],
            useCashList:[],
            storeList:[],
            vipRightTypeData:[{"id":"0","name":"请选择"},{"id":"2","name":"会员专属套装折扣"},
              {"id":"3","name":"新品尝鲜权益"},
              {"id":"4","name":"秒杀"},
              {"id":"12","name":"秒杀预约"},
              {"id":"5","name":"提前秒杀"},
              {"id":"6","name":"5元私人定制礼品"},
              {"id":"7","name":"免费私人定制礼品"},
              {"id":"8","name":"LV4专属赠品"},
              {"id":"9","name":"LV5专属赠品"},
              {"id":"10","name":"Foodie Pass商城"},
              {"id":"11","name":"门店随时9折"},
            ],
            md5str:"",
            form:{
                promotionId:"",
                promotionName:"",
                unit:"",
                createTime:null,
                beginTime:"",
                endTime:"",
                promotionType:"1",
                activeNo:"",
                bindCode:"",
                useCoupon:1,
                saled:0,
                userLimitCount:0,
                productId:"",
                promotionPrice : "",
                originPrice : "",
                vipDayRight : 1,
                vipEverydayRight : 1,
                limitCount:0,
                productType:4,
                isvip : "0",
                vipRightType : "",
                formProducts : [],
                limitType:1,
                countdown:0,
                isFreeFreight:"0",
                storeCode:'',
                shareEnable:1
            }
        }
    },
    components:{
        pictureM,
        productCash
    },
    //挂载时候执行
    mounted(){
        this.getStoreList('')
        // this.getPromotion();
        this.getProductSelect();
        this.getOptionActiveList();
        this.getLimitTypeList();
        this.getConfigUseStatusList()
    },
    methods:{
        getPromotion(){
            if(this.promotionId != 0){
                getPromotionDetail({"promotionId":this.promotionId}).then((res) => {
                    this.loading = false;
                    // this.form = res.data.value;
                    this.form.promotionId = this.promotionId;
                    this.form.promotionName = res.data.value.promotionName;
                    this.form.unit = res.data.value.unit;
                    this.form.createTime = res.data.value.createTime;
                    this.form.beginTime = res.data.value.beginTime;
                    this.form.endTime = res.data.value.endTime;
                    this.form.promotionType = res.data.value.promotionType;
                    this.form.activeNo=res.data.value.activeNo;
                    this.form.bindCode = res.data.value.bindCode;
                    this.form.useCoupon=res.data.value.useCoupon;
                    this.canUseCash=res.data.value.useCoupon;
                    this.form.saled=res.data.value.saled;
                    this.form.countdown=res.data.value.countdown;
                    this.form.limitType=res.data.value.limitType==null?1:res.data.value.limitType;
                    this.form.userLimitCount=res.data.value.userLimitCount;
                    this.form.promotionProductId = res.data.value.promotionProductId;
                    this.form.productId = res.data.value.productId;
                    this.form.promotionPrice = res.data.value.promotionPrice;
                    this.form.originPrice = res.data.value.originPrice;
                    this.form.limitCount=res.data.value.limitCount;
                    this.form.productType = res.data.value.productType;
                    this.form.isvip = res.data.value.isvip;
                    this.form.vipRightType = res.data.value.vipRightType;
                    this.form.vipDayRight = res.data.value.vipDayRight;
                    this.form.vipEverydayRight = res.data.value.vipEverydayRight;

                    this.form.promotionType = "" + this.form.promotionType;
                    this.form.isvip = "" + this.form.isvip;
                    this.form.vipRightType = this.form.vipRightType == null ? "" : "" + this.form.vipRightType;
                    this.form.isvip = "" + this.form.isvip;
                    this.activeData = res.data.value.activeData;
                    this.form.formProducts = res.data.value.formProducts;
                    this.md5str = res.data.value.md5str;
                    this.form.isFreeFreight=res.data.value.isFreeFreight;
                    this.form.shareEnable=res.data.value.shareEnable;
                    if (res.data.value.storeCode && typeof res.data.value.storeCode === 'string') {
                        this.form.storeCode = res.data.value.storeCode.split(',');
                    }
                    console.log('form',this.form);
                    console.log('activeData',this.activeData);
                    console.log('formProducts',this.form.formProducts);

                })
            }else {
                this.loading = false;
            }
        },
        getProductSelect(){
            getProducts().then((res1) => {
                this.products = res1.data.value;
                console.log('products',this.products);
            });
        },
        getStoreList(name){
                 getWxStoreSearch({name:name}).then((res) => {
                    console.log(res);
                    this.storeList = res.data.value
                    this.getPromotion()
                });
            },
        getLimitTypeList(){
            getPromotionLimitTypeList().then((res1) => {
                this.limitTypeData = res1.data.value;
                console.log('limitTypeData',this.limitTypeData);
            });
        },
        getOptionActiveList(){
            if(this.promotionId == 0){
                getOptionActiveList().then((res1) => {
                    this.activeData = res1.data.value;
                    console.log('activeData',this.activeData);
                });
            }
        },
        handleStoreCodesChange(value) {
                console.log('Selected store codes:', value);
                this.form.storeCode = Array.isArray(value) ? value : [value];
            },
        getConfigUseStatusList(){
            getMallItemConfigUseStatusList().then((res) => {
                this.useCashList = res.data.value;
            });
        },
        //定义查询方法
        handleItemChange(row){
            console.log("this.form.formProducts",this.form.formProducts);
            console.log("row",row);
            console.log("this.products",this.products);
            console.log("this.products.length",this.products.length);
            for(var i = 0 ; i < this.products.length; i++){
                console.log("6666666666666666");
                console.log("row.proId",row.proId + " = " + this.products[i].proId + " : " + (row.proId === this.products[i].proId));
                if(row.proId === this.products[i].proId){
                    console.log("row.proId",row.proId);
                    console.log("products.proPrice",this.products[i].proPrice);
                    row.barCode = this.products[i].barCode;
                    row.price = this.products[i].proPrice;
                    row.originPrice = this.products[i].proPrice1?this.products[i].proPrice1:this.products[i].proPrice;
                }
            }
            this.handleOriginPriceChange();
        },
        handleOriginPriceChange(){
            console.log("handleOriginPriceChange.this.form.formProducts",this.form.formProducts);
            var salePrice = 0;
            for(var i = 0 ; i < this.form.formProducts.length; i++){
                console.log("salePrice",salePrice);
                console.log("this.form.formProducts.price",this.form.formProducts[i].price);
                console.log("parseFloat(this.form.formProducts.price)",parseFloat(this.form.formProducts[i].price));
                console.log("this.form.formProducts.proCount",this.form.formProducts[i].proCount);
                console.log("parseFloat(this.form.formProducts.proCount)",parseFloat(this.form.formProducts[i].proCount));
                salePrice = salePrice + parseFloat(this.form.formProducts[i].originPrice) * parseFloat(this.form.formProducts[i].proCount);
            }
            this.form.originPrice = salePrice;
        },
        addPromotion(data){
            console.log("data",data);
            if(data.promotionName==""){
                this.$message({
                    message:"请输入促销名称",
                    type:'error'
                });
                return;
            }
            if(data.beginTime==""){
                this.$message({
                    message:"请选择开始时间",
                    type:'error'
                });
                return;
            }
            if(data.endTime==""){
                this.$message({
                    message:"请选择结束时间",
                    type:'error'
                });
                return;
            }
            if(data.limitCount===""){
                this.$message({
                    message:"请输入限量数",
                    type:'error'
                });
                return;
            }
            if(data.userLimitCount===""){
                this.$message({
                    message:"请输入每单限购量",
                    type:'error'
                });
                return;
            }
            if(data.saled===""){
                this.$message({
                    message:"请输入虚拟销售数",
                    type:'error'
                });
                return;
            }
            if(data.formProducts.length === 0){
                this.$message({
                    message:"请选择商品",
                    type:'error'
                });
                return;
            }
            if(data.promotionPrice===""){
                this.$message({
                    message:"请输入销售价",
                    type:'error'
                });
                return;
            }
            if (Array.isArray(data.storeCode)) {
                data.storeCode = data.storeCode.join(',');
            }
            delete data["activeData"];
            console.log(data);
            this.loading = true;
            
            addPromotionDetail({'promotionStr':data,'md5Str':this.md5str}).then((res) => {
                if(res.data.success){
                    this.$message({
                        message:res.data.message,
                        type:'success'
                    });
                    if(this.promotionId==0){
                        this.promotionId = res.data.value
                        this.$router.replace({path:'/promotionlist/detail/:id',name: 'PromotionDetail',params:{id:res.data.value},query:{promotionId:res.data.value,picType:'',picFrom:'noReturn'}})
                    }
                    this.tabSel = 'tab1'
                }else{
                    this.$message({
                        message:res.data.message,
                        type:'error'
                    });
                }
                this.loading = false;
            });
        },
        addRow(){
            this.form.formProducts.push({
                proId:'',
                // barcode:'',
                proCount:1,
                price:'',
                originPrice:''
            })
        },
        delRow(index){
            this.form.formProducts.splice(index,1);
            this.handleOriginPriceChange();
        },
        /*saveProduct(data){
            if(data.promotionId==""){
                this.$message({
                    message:"请选择商品类型",
                    type:'error'
                });
                return;
            }
            if(data.productType==""){
                this.$message({
                    message:"请选择商品类型",
                    type:'error'
                });
                return;
            }
            if(data.productId==""){
                this.$message({
                    message:"请选择商品",
                    type:'error'
                });
                return;
            }
            if(data.promotionPrice==""){
                this.$message({
                    message:"请输入销售价",
                    type:'error'
                });
                return;
            }
            if(data.limitCount==""){
                this.$message({
                    message:"请输入限购数",
                    type:'error'
                });
                return;
            }
            if(data.sequence==""){
                this.$message({
                    message:"请输入排序号",
                    type:'error'
                });
                return;
            }
            addPromotionProduct(data).then((res) => {
                //console.log(res);
                if(res.data.success){
                    this.$message({
                        message:res.data.message,
                        type:'success'
                    });
                    this.dialogProductVisible=false;
                    this.getList();
                }else{
                    this.$message({
                        message:res.data.message,
                        type:'error'
                    });
                }
            });
        },*/
        dateTimeFormatter(row,column,cellValue){
            return cellValue;//(new Date(cellValue).format("yyyy-MM-dd HH:mm:ss"));
        },
        formatDate(datetime) {
            var date = new Date(datetime);
            var year = date.getFullYear(),
                month = ("0" + (date.getMonth() + 1)).slice(-2),
                sdate = ("0" + date.getDate()).slice(-2),
                hour = ("0" + date.getHours()).slice(-2),
                minute = ("0" + date.getMinutes()).slice(-2),
                second = ("0" + date.getSeconds()).slice(-2);
            // 拼接
            var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
            // 返回
            return result;
        },
        returnHistory(){
            window.history.go(-1)
        }
    }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.detail-container {
    padding: 10px 20px;

    .header-return {
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
    }

    .header-btn {
        float: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/editDetail/promotiondetail.vue